/**
 * Created by piotr.pozniak@thebeaverhead.com on 04/04/2024
 */

import React, { useContext } from "react";
import classnames from "classnames";
import useShowPopup from "../../../hooks/useShowPopup";
import SharePopup from "../../../WidgetsComponents/SharePopup";
import WidgetSettingsContext from "../../../contexts/WidgetSettingsContext";
import { ShareIcon } from "../../../consts";
import { useTranslation } from "react-i18next";
import { useCalendarStore } from "../../../hooks/redux/calendar";

/**
 *
 * @param {String} title
 * @param {String} url
 * @param {String} text
 * @param {String} [className]
 * @returns {React.JSX.Element|null}
 * @constructor
 */
const ShareCalendarButton = ({
  title,
  url,
  text,
  className = "dc-calendar-share-button",
}) => {
  const { onShow, showPopup } = useShowPopup({ url, title, text });
  const widgetSettings = useContext(WidgetSettingsContext);
  const { t } = useTranslation();
  const { calendar } = useCalendarStore();

  const showCalendarShare = widgetSettings["calendarShowShare"] === 1;

  const popup = showPopup ? (
    <SharePopup
      url={url}
      title={title}
      text={text}
      onClose={onShow}
      widgetSelectorID={`dce_calendar__${calendar.model.uuid}`}
    />
  ) : null;

  if (!showCalendarShare) {
    return null;
  }

  return (
    <div>
      <button
        type="button"
        onClick={onShow}
        className={classnames("dce-btn-reset", className)}
        aria-haspopup="dialog"
      >
        <i className={"material-icons"} aria-hidden="true">
          {ShareIcon}
        </i>{" "}
        {t("Share")}
      </button>
      {popup}
    </div>
  );
};

export default ShareCalendarButton;
